// 日本语
module.exports = {
	common: {
		common_0: "加载中",
		common_1: "提示",
		common_2: "取消",
		common_3: "确定"
	},
	Message: {
		Message_01: "データ登録が成功しました。",
		Message_02: "データ登録に失敗しました。",
		Message_03: "入力された条件を満たすデータはありません。",
		Message_04: "印刷されたデータは1万件を超えた，絞り込み条件を追加してください。",		
		Message_05: "こちらは必須項目です。",
        Message_06: "請求に失敗しました。",
		Message_07: "請求に成功しました。",
		Message_08: "データ保存に失敗。",
		Message_09: "セーブデータが成功。",	
		Message_10: "保存が成功しました。引き続き追加しますか。",
		Message_11: "提示",
		Message_12: "削除してもよろしいですか？",
		Message_13: "注意",
		Message_14: "削除失敗",
		Message_15: "削除完了",
		Message_16: "削除項目を選んでください。",
	},
	login: {
		login_0: "PO+S PORTAL",
		login_1: "会社ID",
		login_2: "ユーザID",
		login_3: "パスワード",
		login_4: "会社IDを入力してください",
		login_5: "ログインIDを入力してください",
		login_6: "パスワードを入力してください",
		login_7: "データが入力されていない",
		login_8: "ログインできません。入力内容を見直してください。",
		login_9: "ログイン成功",
		login_10: "インターネットや無線LAN(wifi）が接続できない",		
		login_11: "日本語",
		login_12: "簡体字",
		login_13: "繁体字",
		login_14: "ログイン",
		login_15: "言語の変更に失敗しました"
	},
	header: {
		header_0: "PO+S PORTAL",
		header_1: "日本語",
		header_2: "簡体字",
		header_3: "繁体字",
		header_4: "英語",
		header_5: "元に戻す",
		header_6: "最大化",
		header_7: "有",
		header_8: "未読メッセージ",
		header_9: "マイページ",
		header_10: "個人情報",
		header_11: "ログアウト"
	},
	tags: {
		tags_0: "タブ操作",
		tags_1: "他のタブを閉じる",
		tags_2: "全て閉じる"
	},
sidebar: {
		sidebar_0: "系统首页",
		sidebar_1: "菜单管理",
		sidebar_2: "角色管理",
		sidebar_3: "用户管理",
		sidebar_4: "会社管理",
		
		sidebar_5: "商品移动",
		sidebar_6: "商品移动出库处理",
		sidebar_7: "商品移動履歴",
		sidebar_8: "ロール管理",
		sidebar_9: "ユーザ管理",
		sidebar_10: "売上金種",
		sidebar_11: "在庫集計（現在庫）",
		sidebar_12: "在庫集計（月末在庫）",
		sidebar_13: "菜单编辑",
	},
	
	forgetpwd: {
		forgetpwd_0: "パスワード再設定",
		forgetpwd_1: "メールアドレス",
		forgetpwd_2: "認証コード",
		forgetpwd_3: "6~18桁まで新しいパスワード",
		forgetpwd_4: "パスワードは6~18桁まで",
		forgetpwd_5: "認証コード取得",
		forgetpwd_6: "新パスワードと再入力パスワードが一致しません。",
		forgetpwd_7: "確定",
		forgetpwd_8: "思い出した",
		forgetpwd_9: "直接ログイン",
		forgetpwd_10: "認証コードを入力してください",
		forgetpwd_11: "メール形式が正しくありません",
		forgetpwd_12: "XX秒再取得",
		forgetpwd_13: "再取得",
		forgetpwd_14: "認証コードが正しくありません",
		forgetpwd_15: "ログイン成功",
		forgetpwd_16: "メールとパスワードを入力してください",
		forgetpwd_17: "メールアドレスを入力してください",
		forgetpwd_18: "認証コードが正しくありません",
		forgetpwd_19: "変更完了",
		forgetpwd_20: "まずこのメールアドレスを登録してください。",
		forgetpwd_21: "認証コードの有効期限切れ",
		forgetpwd_22: "変更失敗",
		forgetpwd_23: "6-18桁の新しいパスワードを繰り返してください。",
		forgetpwd_24: "メールボックスと認証コードが一致していません。",
		forgetpwd_25: "認証コードは6ビットでなければなりません。",
		forgetpwd_26: "取得中"
	},

	// rolesList: {
	// 	rolesList_0: "ロール管理",
	// 	rolesList_1: "ロール名で検索",
	// 	rolesList_2: "開始日付",
	// 	rolesList_3: "終了日付",
	// 	rolesList_4: "検索",
	// 	rolesList_5: "追加",
	// 	rolesList_6: "ロール名",
	// 	rolesList_7: "備考",
	// 	rolesList_8: "作成人",
	// 	rolesList_9: "作成時間",
	// 	rolesList_10: "操作",
	// 	rolesList_11: "編集",
	// 	rolesList_12: "削除",
	// 	rolesList_13: "ロール名追加",
	// 	rolesList_14: "ロール名編集",
	// 	rolesList_15: "戻る",
	// 	rolesList_16: "確定",
	// 	rolesList_17: "loading",
	// 	rolesList_18: "全選択",
	// 	rolesList_19: "リセット",
	// 	rolesList_20: "ロール名を入力してください",
	// 	rolesList_21: "請求失敗しました",
	// 	rolesList_22: "削除してもよろしいですか？",
	// 	rolesList_23: "注意",
	// 	rolesList_24: "削除失敗",
	// 	rolesList_25: "削除完了",
	// 	rolesList_26: "提出してもよろしいですか？",
	// 	rolesList_27: "同じロール名は複数の追加ができません",
	// 	rolesList_28: "操作失敗",
	// 	rolesList_29: "操作完了",
	// 	rolesList_30: "全ての管理権限は運営管理人を持ち、管理権限修正禁止",
	// 	rolesList_31: "リスト",
	// 	rolesList_32: "メニュー",
	// 	rolesList_33: "ボタン",
	// 	rolesList_34: "顶级菜单", //未处理
	// 	rolesList_35: "ロール管理権限"
	// },
	// menusList: {
	// 	menusList_0: "管理権限",
	// 	menusList_1: "请搜索菜单名称", //未处理
	// 	menusList_2: "検索",
	// 	menusList_3: "追加",
	// 	menusList_4: "loading",
	// 	menusList_5: "管理権限名称",
	// 	menusList_6: "マーク",
	// 	menusList_7: "種類",
	// 	menusList_8: "リスト",
	// 	menusList_9: "メニュー",
	// 	menusList_10: "ボタン",
	// 	menusList_11: "上级菜单", //未处理
	// 	menusList_12: "菜单URL", //未处理
	// 	menusList_13: "授权标识", //未处理
	// 	menusList_14: "排序", //未处理
	// 	menusList_15: "操作",
	// 	menusList_16: "編集",
	// 	menusList_17: "削除",
	// 	menusList_18: "新增菜单", //未处理
	// 	menusList_19: "编辑菜单", //未处理
	// 	menusList_20: "菜单类型", //未处理
	// 	menusList_21: "名称", //未处理
	// 	menusList_22: "顶级菜单", //未处理
	// 	menusList_23: "授权标识", //未处理
	// 	menusList_24: "菜单路由", //未处理
	// 	menusList_25: "URL格式：", //未处理
	// 	menusList_26: "1.常规业务开发的功能URL，如用户管理，pages目录下页面路径为 /users/usersList, 此处填写 /users/usersList。",//未处理
	// 	menusList_27: "2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。",//未处理
	// 	menusList_28: "示例：用户管理：/users/usersList 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000",//未处理
	// 	menusList_29: "排序编号",//未处理
	// 	menusList_30: "菜单图标",//未处理
	// 	menusList_31: "菜单图标名称（如：el-icon-s-home）",//未处理
	// 	menusList_32: "戻る",
	// 	menusList_33: "確定",
	// 	menusList_34: "空欄にできません",
	// 	menusList_35: "請求失敗しました",
	// 	menusList_36: "削除してもよろしいですか？",
	// 	menusList_37: "注意",
	// 	menusList_38: "削除失敗",
	// 	menusList_39: "削除完了",
	// 	menusList_40: "提出してもよろしいですか？",
	// 	menusList_41: "菜单名称不能重复新增",//未处理
	// 	menusList_42: "操作失敗",
	// 	menusList_43: "操作完了"
	// },
	
	
	
	
	Dashboard: {
		Dashboard_0: "システムトップ",
		Dashboard_1: "今週店舗数",
		Dashboard_2: "今週ガイド数",
		Dashboard_3: "今週代理店数",
		Dashboard_4: "今週紹介料精算完了数",
		Dashboard_5: "先週と比べ",
		Dashboard_6: "通知",
		Dashboard_7: "もっと見る",
		Dashboard_8: "订单销售金额统计",  //未处理
		Dashboard_9: "7日間紹介料精算完了統計",
		Dashboard_10: "3日間",
		Dashboard_11: "7日間",
		Dashboard_12: "30日間",
		Dashboard_13: "日付",
		Dashboard_14: "销售金额", //未处理
		Dashboard_15: "近3天成交统计", //未处理
		Dashboard_16: "近30天成交统计", //未处理
		Dashboard_17: "新規登録統計",
		Dashboard_18: "ガイド",
		Dashboard_19: "店舗",
		Dashboard_20: "代理店",
		Dashboard_21: "請求失敗しました",
		Dashboard_22: "店舗ジャンル"
	},
	
	
	T13011: {
		T13011_0: "伝票ID",
		T13011_1: "担当者",
		T13011_2: "入力日",
		T13011_3: "入荷伝票ID",
		T13011_4: "移動元",
		T13011_5: "備考",
		T13011_6: "移動先",
		T13011_7: "JAN ",
		T13011_8: "数量合計",
		T13011_9: "メーカー",
		T13011_10: "大分類 ",
		T13011_11: "中分類",
		T13011_12: "小分類 ",
		T13011_13: "品番",
		T13011_14: "品名",
		T13011_15: "品名2",
		T13011_16: "属性1 ",
		T13011_17: "属性2",
		T13011_18: "属性3 ",
		T13011_19: "標準価格",
		T13011_20: "数量",
		T13011_21: "金額",
		T13011_22: "備考",
		T13011_23: "金額",
		T13011_24: "数据保存成功。",
		T13011_25: "数据保存失败。",
		T13011_26: "请求失败",
		T13011_27: "商品移动",
		T13011_28: "盘点中，无法进行商品调拨。\n盘点结束后，请再次录入。",
		T13011_29: "无数据",
		T13011_30: "運送業者",
		T13011_31: "送り状番号",
		T13011_32: "入力されたJANが登録されておりません。",
		T13011_33: "表单验证失败",
		T13011_34: "リセット",
		T13011_35: "登 録",		
		T13011_36: "即時入庫",
		T13011_37: "删除",
			
	},
	T13021: {
		T13021_0: "商品移動",		
		T13021_1:"メーカー",
		T13021_2:"移動元",
		T13021_3:"伝票ID",
		T13021_4:"状態",
		T13021_5:"JAN",
		T13021_6:"移動先",
		T13021_7:"キーワード",
		T13021_8:"備考",
		T13021_9:"品番",
		T13021_10:"処理日時",
		T13021_11:"品名",
		T13021_12:"移動伝票ID",
		T13021_13:"移動状態 ",
		T13021_14:"移動元 ",
		T13021_15:"移動先 ",
		T13021_16:"入力者 ",
		T13021_17:"入力日 ",
		T13021_18:"発送者 ",
		T13021_19:"発送日 ",
		T13021_20:"入庫者 ",
		T13021_21: "入庫日 ",
		T13021_22: "送り状ID ",
		T13021_23:"リセット",
		T13021_24:"导出Excel",
		T13021_25:"",
		T13021_26:"搜索",
		T13021_27:"发送",
		T13021_28:"入库",
		T13021_29:"再发行",
		T13021_30:"照会",
		T13021_31:"编辑",
		T13021_32:"删除",	
		T13021_33:"品名",
		T13021_34:"削除も表示",
		T13021_35:"自店に関係あるものだけ表示",
		T13021_36: "開始日付",
		T13021_37: "終了日付",
		T13021_38: "请求失败",
		T13021_39: "操作",
		T13021_40: "您确定要操作吗？",
		T13021_41: "提示",
		T13021_42: "操作失败",
		T13021_43: "操作成功",
		T13021_table0: "JAN",
		T13021_table1: "メーカー",		
		T13021_table2: "大分類",
		T13021_table3: "中分類",
		T13021_table4: "小分類",		
		T13021_table5: "品番",
		T13021_table6: "品名",
		T13021_table7: "品名2",		
		T13021_table8: "標準価格",
		T13021_table9: "数量",
		T13021_table10: "金額",		
		T13021_table11: "備考",
		T13021_table12: "删除标志",
		T13021_table13: "社内JAN",
		T13021_44: "Excelファイルを出力してもよろしいですか？",
		T13021_45: "确定",
		T13021_46: "取消",
		T13021_47: "移動元店舗",
		T13021_48: "移動先店舗",
		T13021_49: "ブランド",
		T13021_50: "サイズ",
		T13021_51: "カラー",
		T13021_52: "移動リスト",
		T13021_53: "明細行を選択してください。",		
		},
	NavEdit:{
		NavEdit_0:"メニュー管理",
		NavEdit_1:"親メニュー",
		NavEdit_2:"ソート順",
		NavEdit_3:"非表示",
		NavEdit_4:"画面別名",
		NavEdit_5:"ナビタイトル(日本)",
		NavEdit_6:"ナビタイトル(中国)",
		NavEdit_7:"ナビタイトル(台湾)",
		NavEdit_8:"サブタイトル",
		NavEdit_9:"リンク",
		NavEdit_10:"備考",
		NavEdit_11:"権限",
		NavEdit_12:['表示(Show)','照会(View)','追加(Add)','変更(Edit)','削除(Delete)','承認(Audit)','コメント(Reply)','確定(Confirm)','キャンセル(Cancel)','廃棄(Invalid)','生成(Build)','インストール(Instal)','アンインストール(Unload)','バックアップ(Back)','回復(Restore)','替换(Replace)'],
        NavEdit_13:"*数字、昇順",
		NavEdit_14:"非表示に設定したらサイドメニューに表示しない",
		NavEdit_15:"権限名にはアルファベット、数字、アンダースコアのみ入力可能、サイドメニューの物理名と同じ。",
		NavEdit_16:"*メニューのタイトルが100文字以内",
		NavEdit_17:"オプション項目、メニュー名が２つ以上ある場合に使う",
		NavEdit_18:"子メニューある場合は入力しないでください。",
		NavEdit_19:"空白で可能",
		NavEdit_20:"空ではない",
		NavEdit_21:"保存",
		NavEdit_22:"戻る",
		NavEdit_23:'请求失败',
		NavEdit_24:'保存に成功しました',
		NavEdit_25:'保存に失敗しました',
		NavEdit_26:'フォームの検証に失敗しました',
		NavEdit_27:'この権限名はすでに使われています。変更してください。',
		NavEdit_28:'この権限名は利用可能です。',
		NavEdit_29:'ナビゲーションのドロップダウンリストを選択してください。',
	},
	NavList:{
		NavList_0:"メニュー管理",
		NavList_1:"新规",
		NavList_2:"保存",
		NavList_3:"画面別名",
		NavList_4:"タイトル",
		NavList_5:"非表示",
		NavList_6:"ソート順",
		NavList_7:"操作",
		NavList_8:"子レベル追加",
		NavList_9:"变更",
		NavList_10:"删除",

	},
	Role_List: {
			Role_List: "ロール管理",
			Role_List_0: "新規",
			Role_List_1: "すべて",
			Role_List_2: "削除",		
			Role_List_3: "選択",
			Role_List_4: "役割名",
			Role_List_5: "タイプ",
			Role_List_6: "操作",
			Role_List_7: "システムユーザ",
			Role_List_8: "変更",
			Role_List_9: "役割配属",
			Role_List_10: "Admin",
			Role_List_11: "",
			Role_List_12: "",
			Role_List_13: "",
			Role_List_14: "",
			
		},
	Role_Edit:{
		Role_Edit_0:"ロール管理",
		Role_Edit_1:"役割タイプ",
		Role_Edit_2:"役割名(日本)",
		Role_Edit_3:"役割名(中国)",
		Role_Edit_4:"役割名(台湾)",
		Role_Edit_5:"サイドメニュー",
		Role_Edit_6:"すべて",
		Role_Edit_7:"権限",
		Role_Edit_8:"保存",
		Role_Edit_9:"戻る",
		Role_Edit_10:"管理者権限",
		Role_Edit_11:"役割名(日本)入力してください。",
		Role_Edit_12:"役割名(中国)入力してください。",
		Role_Edit_13:"役割名(台湾)入力してください。",
		Role_Edit_14:"请选择役割タイプ。",
		Role_Edit_15:"表单验证失败",
	},
	AnalysisGoldstat: {
		AnalysisGoldstat_0: "昇順",
		AnalysisGoldstat_1: "降順"
	},
	Analysiswholesale: {
		Analysiswholesale_0: "昇順",
		Analysiswholesale_1: "降順"
	},
	Analysissales: {
		Analysissales_0: "昇順",
		Analysissales_1: "降順"
	},
	Analysissalesec: {
		Analysissalesec_0: "昇順",
		Analysissalesec_1: "降順"
	},
	Analysismove: {
		Analysismove_0: "昇順",
		Analysismove_1: "降順"
	},
	Managers: {
		Managers_0: "役割名を選択",
		Managers_1: "社員コード/氏名（かな）/メールアドレス",
		Managers_2: "アカウント名",
		Managers_3: "氏名",
		Managers_4: "電話番号",
		Managers_5: "役割名",
		Managers_6: "登録時間",
		Managers_7: "ステータス",
		Managers_8: "操作",
		Managers_9: "变更",
		Managers_10: "削除してよろしいでしょうか?",
		Managers_11: "提示",
		Managers_12: "確定",
		Managers_13: "キャンセル",
		Managers_14: "削除に成功しました",
		Managers_15: "キャンセルしました",
		Managers_16: "正常",
		Managers_17: "禁止",
		Managers_18: "請求に失敗しました",
		Managers_19: "削除に失敗しました",
		Managers_20: "ユーザ管理",
		Managers_21: "削除",
		Managers_22:"削除する情報を選択してください。",
		
		Managers_23: "役割名を選択",
		Managers_24: "内容を入力してください",
		Managers_25: "保存",
		Managers_26: "戻る",
		Managers_27: "保存に成功する",
		Managers_28: "保存に失敗",
		Managers_29: "請求に失敗しました",	
		Managers_30: "ユーザ管理",
		Managers_31: "注意",
		Managers_32: "登録してもよろしいですか？",
	},
	itemfileselected:{
		itemfileselected_0:'表示項目',
		itemfileselected_1:'行項目',
		itemfileselected_2:'選択してください',
		
		itemfileselected_3:'集計項目',
		itemfileselected_4:'列項目',
		itemfileselected_5:'検索',
		itemfileselected_6:'リセット',
		itemfileselected_7:'繰り返しの選択を禁止します',
		itemfileselected_8:'行を選んでください',
		itemfileselected_9:'検索結果',
	},
	home: {
		home_0: "一定時間操作が確認できなかったため、セキュリティの観点からログアウトいたしました。再度ログインしてください。",
		home_1: "エラー",
		home_2: "確定",
		home_3: "請求に失敗する"
	},
	
	Analysisinventorycurrent: {
		Analysisinventorycurrent_0: "在庫集計（現在庫）",
		Analysisinventorycurrent_1: "フィルタ",
		Analysisinventorycurrent_2: "店舗",
		Analysisinventorycurrent_3: "分類",
		Analysisinventorycurrent_4: "大分類",
		Analysisinventorycurrent_5: "中分類",
		Analysisinventorycurrent_6: "小分類",
		Analysisinventorycurrent_7: "メーカー",
		Analysisinventorycurrent_8: "JAN",
		Analysisinventorycurrent_9: "品番",
		Analysisinventorycurrent_10: "品名1",
		Analysisinventorycurrent_11: "品名2",
		Analysisinventorycurrent_12: "属性1",
		Analysisinventorycurrent_13: "属性2",
		Analysisinventorycurrent_14: "グループ1",
		Analysisinventorycurrent_15: "グループ2",
		Analysisinventorycurrent_16: "最終入荷日",
		Analysisinventorycurrent_17: "仕入先",
		Analysisinventorycurrent_18: "検索",
		Analysisinventorycurrent_19: "要求に失敗しました",
		Analysisinventorycurrent_20: "データなし",
		Analysisinventorycurrent_21: "最終入荷日を選んでください。",
		Analysisinventorycurrent_22: "データ件数が10000件を超えています。検索条件を見直してください",
		Analysisinventorycurrent_23: "データ件数が30000件を超えています。検索条件を見直してください",
		Analysisinventorycurrent_24: "昇順",
		Analysisinventorycurrent_25: "降順",
	},
	Analysisinventoryeom: {
		Analysisinventoryeom_0: "在庫集計（月末在庫）",
		Analysisinventoryeom_1: "フィルタ",
		Analysisinventoryeom_2: "店舗",
		Analysisinventoryeom_3: "分類",
		Analysisinventoryeom_4: "大分類",
		Analysisinventoryeom_5: "中分類",
		Analysisinventoryeom_6: "小分類",
		Analysisinventoryeom_7: "メーカー",
		Analysisinventoryeom_8: "JAN",
		Analysisinventoryeom_9: "品番",
		Analysisinventoryeom_10: "品名1",
		Analysisinventoryeom_11: "品名2",
		Analysisinventoryeom_12: "属性1",
		Analysisinventoryeom_13: "属性2",
		Analysisinventoryeom_14: "グループ1",
		Analysisinventoryeom_15: "グループ2",
		Analysisinventoryeom_16: "年月",
		Analysisinventoryeom_17: "検索",
		Analysisinventoryeom_18: "请求失败",
		Analysisinventoryeom_19: "昇順",
		Analysisinventoryeom_20: "降順",
		Analysisinventoryeom_21: "年月を選んでください",
		Analysisinventoryeom_22: "データなし",
		Analysisinventoryeom_23: "店舗を選んでください",
		Analysisinventoryeom_24: "データ件数が10000件を超えています。検索条件を見直してください",
		Analysisinventoryeom_25: "データ件数が30000件を超えています。検索条件を見直してください",
		
	},
	
	
	menusList: {
		menusList_0: "管理権限",
		menusList_1: "メニューを検索", 
		menusList_2: "検索",
		menusList_3: "追加",
		menusList_4: "loading...",
		menusList_5: "管理権限名称",
		menusList_6: "マーク",
		menusList_7: "種類",
		menusList_8: "リスト",
		menusList_9: "メニュー",
		menusList_10: "ボタン",
		menusList_11: "上位メニュー", 
		menusList_12: "メニューURL", 
		menusList_13: "識別コード", 
		menusList_14: "順番", 
		menusList_15: "操作",
		menusList_16: "編集",
		menusList_17: "削除",
		menusList_18: "新規登録", 
		menusList_19: "編集", 
		menusList_20: "タイプ：", 
		menusList_21: "名称：", 
		menusList_22: "トップレベル", 
		menusList_23: "識別コード：", 
		menusList_24: "パス：", 
		menusList_25: "コメント：", 
		menusList_26: "①内部ページ：フォルダー「pages」の中のパスは「/users/usersList」の場合は「/users/usersList」を入力してください。",
		menusList_27: "②外部リンク：「https://www.manecu.com」を入力してください。「https://」「http://」は必要です。",
		menusList_28: "例：ユーザー管理：/users/usersList 入れ子：http://www.manecu.com ネストページ：http://127.0.0.1:8000",
		menusList_29: "順番：",
		menusList_30: "アイコン名：",
		menusList_31: "アイコン名（例：el-icon-s-home）",
		menusList_32: "戻る",
		menusList_33: "登録",
		menusList_34: "空欄にできません",
		menusList_35: "登録に失敗しました",
		menusList_36: "削除してもよろしいですか？",
		menusList_37: "注意",
		menusList_38: "削除失敗",
		menusList_39: "削除完了",
		menusList_40: "登録してもよろしいですか？",
		menusList_41: "アイコン名は既に登録されております。新規できません。",
		menusList_42: "操作失敗",
		menusList_43: "操作完了",
		menusList_44: "上位メニュー：",
	},
	rolesList: {
		rolesList_0: "役職管理",
		rolesList_1: "役職名で検索",
		rolesList_2: "開始日付",
		rolesList_3: "終了日付",
		rolesList_4: "検索",
		rolesList_5: "追加",
		rolesList_6: "役職名",
		rolesList_7: "備考",
		rolesList_8: "作成人",
		rolesList_9: "作成時間",
		rolesList_10: "操作",
		rolesList_11: "編集",
		rolesList_12: "削除",
		rolesList_13: "役職名追加",
		rolesList_14: "役職名編集",
		rolesList_15: "戻る",
		rolesList_16: "登録",
		rolesList_17: "loading...",
		rolesList_18: "全選択",
		rolesList_19: "リセット",
		rolesList_20: "役職名を入力してください",
		rolesList_21: "登録に失敗しました",
		rolesList_22: "削除してもよろしいですか？",
		rolesList_23: "注意",
		rolesList_24: "削除失敗",
		rolesList_25: "削除完了",
		rolesList_26: "登録してもよろしいですか？",
		rolesList_27: "同じ役職名は複数の追加ができません",
		rolesList_28: "操作失敗",
		rolesList_29: "操作完了",
		rolesList_30: "全ての管理権限は運営管理人を持ち、管理権限修正禁止",
		rolesList_31: "リスト",
		rolesList_32: "メニュー",
		rolesList_33: "ボタン",
		rolesList_34: "トップレベル", 
		rolesList_35: "役職管理権限",
		rolesList_36: "役職名：",
		rolesList_37: "コメント：",
		rolesList_38: "フィルタ",
		rolesList_39: "役職管理",
		rolesList_40: "ID",
		rolesList_41: "を削除します。よろしいですか？",
		rolesList_42: "データ削除に成功しました。",
		rolesList_43: "データ削除に失敗しました。",
		rolesList_44: "データ登録に成功しました。",
		rolesList_45: "データ登録に失敗しました。",
		rolesList_46: "入力されたロール名は既に存在しています。\nもう一度お試しください。",
		rolesList_47: "データを登録します。よろしいですか？",
	},
	Category:{
		Category_0:"",
		Category_1:"売上金額",
		Category_2:"売上前年比",
		Category_3:"粗利金額",
		Category_4:"粗利率",
		Category_5:"粗利前年比",
		Category_6:"返品金額",
		Category_7:"返品率",
		Category_8:"仕入金額",
		Category_9:"値入率",
		Category_10:"在庫金額",
		Category_11:"检索",
	}

}